import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import axios from "axios";
import DreamQuestions from "./pages/DreamQuestions";
import CouplesExercises from "./pages/CouplesExercises";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center p-8">
      <div className="max-w-4xl w-full">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-light text-gray-800 mb-4">Therapeutic Tools</h1>
          <p className="text-gray-600 text-lg">Resources for exploration and connection</p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8">
          <Link 
            to="/dream-questions" 
            className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-8 border border-indigo-100 hover:shadow-2xl transition-all duration-300 transform hover:scale-105 group"
            data-testid="dream-questions-link"
          >
            <div className="text-4xl mb-4">💭</div>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3 group-hover:text-indigo-600 transition-colors">Dream Question Generator</h2>
            <p className="text-gray-600 leading-relaxed">
              Explore your dreams through open-ended, relational questions that invite curiosity about your inner world.
            </p>
          </Link>

          <Link 
            to="/couples-exercises" 
            className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-8 border border-rose-100 hover:shadow-2xl transition-all duration-300 transform hover:scale-105 group"
            data-testid="couples-exercises-link"
          >
            <div className="text-4xl mb-4">❤️</div>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3 group-hover:text-rose-600 transition-colors">Couples Connection Exercises</h2>
            <p className="text-gray-600 leading-relaxed">
              Guided exercises for nervous system co-regulation, communication, and deepening relational attunement.
            </p>
          </Link>
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500">
            🔒 All tools are completely private. No data is collected or stored.
          </p>
        </div>
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dream-questions" element={<DreamQuestions />} />
          <Route path="/couples-exercises" element={<CouplesExercises />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
